
import { defineComponent, ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import Header from './Header.vue';
import Footer from './Footer.vue';

export default defineComponent({
  name: 'Layout',
  components: {
    Header,
    Footer
  },
  setup() {
    const route = useRoute();
    const showHeaderFooter = ref(false);
    const setHeaderFooterVisible = path => {
      showHeaderFooter.value = path !== '/login';
    };
    onMounted(() => {
      setHeaderFooterVisible(route.path);
    });
    watch(
      () => route.path,
      path => {
        setHeaderFooterVisible(path);
      }
    );
    return { showHeaderFooter };
  },
  methods: {
    frozenBody() {
      document.body.style.height = '100vh';
      document.body.style.overflow = 'hidden';
    },
    releaseBody() {
      document.body.style.height = '';
      document.body.style.overflow = '';
    }
  }
});
